import React, { FC } from 'react';
import { Box, Typography } from '@mui/material';
import { CancelOutlined as ErrorIcon } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

interface ErrorProps {
  addressView: string;
}

const Error: FC<ErrorProps> = ({ addressView }) => {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        display: 'flex',
        height: '100%',
        width: '100%',
        alignItems: 'flex-end',
        justifyContent: 'center',
      }}
    >
      <Box
        sx={{
          position: 'absolute',
          top: '18%',
          left: '50%',
          transform: 'translate(-50%, -18%)',
          width: '100%',
          padding: '0px 17px',
        }}
      >
        <Typography>{addressView}</Typography>
      </Box>
      <Box
        sx={{
          position: 'absolute',
          top: '25%',
          left: '50%',
          transform: 'translate(-50%, -25%)',
          textAlign: 'center',
        }}
      >
        <ErrorIcon
          sx={{ fontSize: '72px', marginBottom: '15px' }}
          color="error"
        />
      </Box>
      <Box
        sx={{
          position: 'absolute',
          top: '35%',
          left: '50%',
          transform: 'translate(-50%, -35%)',
          textAlign: 'center',
          width: '70%',
        }}
      >
        <Typography
          sx={{ fontSize: '16px', lineHeight: '19px', fontWeight: '300' }}
        >
          {t('error_check_address')}
        </Typography>
      </Box>
    </Box>
  );
};

export default Error;
